import { UserFacade } from '@goparrot/users-v2-sdk';
import { getConfig, getInterceptors } from '@goparrot-dashboard-api/shared';
import { FranchiseUserFacade } from '@goparrot/dashboard-gateway-sdk';

export const userFacade = new UserFacade(getConfig('api/v2/users-v2'), getInterceptors());
export const franchiseUserFacade = new FranchiseUserFacade(getConfig('api/v2/users-v2'), getInterceptors());
export const userFacadeConfig = new UserFacade({ ...getConfig('api/v2/users-v2'), axiosRetryConfig: { retries: 0 } }, getInterceptors());
